import React, { Component } from "react";
import { Redirect } from "react-router";
import InputHandler from "../../shared/javascript/InputHandler";
import SubmissionHandler from "../../shared/javascript/SubmissionHandler";
import { RadioGroup } from "../../shared/Components/RadioGroup";
import { CheckboxGroup } from "../../shared/Components/CheckboxGroup";
import { Textbox } from "../../shared/Components/Textbox";
import { DateSelector } from "../../shared/Components/DateSelector";
import { LoadingModal } from "../../shared/Components/LoadingModal";
import error_messages from "./error_messages.json";
import hilogo from "../../../images/hilogo.png";
import ppo from "../../../images/ppo.png";
import advantage from "../../../images/logo-hmsa-advantage.png";
import mappo from "../../../images/logo-ma-ppo.png";
import medicare from "../../../images/medicare-rx.png";
import qr from "../../../images/qr-code.png";

var inputHandler = new InputHandler(error_messages);
var submissionHandler = new SubmissionHandler(error_messages);

export class Prevalidation extends Component {
  displayName = Prevalidation.name;
  constructor(props) {
    super(props);
    this.state = {
      user_browser: navigator.userAgent,
      endpoint: "api/hawaii/dentalforhealth/prevalidate",
      errors: {
        referral: "",
        other_referral: "",
        conditions: "",
        primary_first_name: "",
        primary_last_name: "",
        member_first_name: "",
        member_last_name: "",
        member_id: "",
        member_dob: "",
        default_error: ""
      },
      user_input: {
        referrals: {
          selected_option: "",
          options: {
            special_delivery_nurse: {
              label: "Special Delivery Nurse",
              is_checked: false
            },
            case_manager: {
              label: "Case Manager",
              is_checked: false
            },
            dental_office: {
              label: "Dental Office",
              is_checked: false
            },
            care_coordinator: {
              label: "Care Coordinator",
              is_checked: false
            },
            other: {
              label: "Other",
              is_checked: false
            }
          }
        },
        other_referral: "",
        conditions: {
          diabetes: {
            label: "Diabetes",
            is_checked: false
          },
          coronary_artery_disease: {
            label: "Coronary Artery Disease",
            is_checked: false
          },
          stroke: {
            label: "Stroke",
            is_checked: false
          },
          oral_cancer: {
            label: "Oral Cancer",
            is_checked: false
          },
          head_and_neck_cancer: {
            label: "Head and Neck Cancer",
            is_checked: false
          },
          sjogrens: {
            label: "Sjögren's Syndrome",
            is_checked: false
          },
          pregnancy: {
            label: "Pregnancy",
            is_checked: false
          },
					copd: {
            label: "Chronic Obstructive Pulmonary Disease",
            is_checked: false
          },
					esrd: {
            label: "End State Renal Disease",
            is_checked: false
          },
					mets: {
            label: "Metabolic Syndrome",
            is_checked: false
          },
        },
        primary_first_name: "",
        primary_last_name: "",
        member_first_name: "",
        member_last_name: "",
        member_id: "",
        member_dob: ""
      },
      form_is_valid: false,
      is_loading: false,
      success: false
    };
  }

  render = () => {
    const {
      errors,
      user_input,
      is_loading,
      form_is_valid,
      success
    } = this.state;

    var referenceTextDisplay = <br />;
    // if 'other' under referral is selected, allow user to enter text
    if (user_input.referrals.selected_option === "other") {
      referenceTextDisplay = (
        <div className="row">
          <div className="col-md-6">
            <Textbox
              label_name="Please tell us who referred you."
              name="other_referral"
              placeholder="Other Referral"
              maxLength="25"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
              required={true}
            />
            {errors.other_referral}
          </div>
        </div>
      );
    } else if (user_input.referrals.selected_option !== "other") {
      // assure submission is available if user clicks away from 'other'
      user_input.other_referral = "";
      errors.other_referral = "";
    }

    var page = (
      <div className="container padding-top">
        <div className="alert alert-info alert-dismissable " role="alert">
          <button
            type="button"
            className="close button button-primary buttonBlue close-btn"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <p>
            If you also have a medical policy through HMSA and have a qualifying 
            medical condition, it is possible that you have already been 
            automatically enrolled into Oral Health for  Total Health. Note: 
            It may take up to a month for us to process your enrollment. Once 
            your enrollment has been processed, you will receive a welcome
            letter in the mail.
          </p>
          <p>
            If you are unsure of your enrollment status please contact Customer
            Service at (808) 948-6440 or toll-free at (800) 792-4672 to verify
            if you have been automatically enrolled.
          </p>
        </div>
        <hr />
        <h2>Member Information</h2>
        <div className="alert alert-info alert-dismissable" role="alert">
          <button
            type="button"
            className="close button button-primary buttonBlue close-btn"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <p>
            To participate in the program you must be enrolled in a dental plan
            offered by HMSA and have at least one of the following conditions!
          </p>
        </div>
        <RadioGroup
          label_name="How did you hear about Oral Health for Total Health?"
          radioButtons={user_input.referrals}
          required={true}
          onChange={e =>
            inputHandler.handleRadioGroupChange(e, this, "referrals")
          }
        />
        {errors.referrals}
        {referenceTextDisplay}
        <CheckboxGroup
          name="conditions"
          label_name="Please check the program qualifying condition(s) that you have:"
          checkboxes={user_input.conditions}
          onChange={e =>
            inputHandler.handleCheckboxGroupChange(e, this, "conditions")
          }
          required={true}
        ></CheckboxGroup>
        {errors.conditions}
        <br />
        <div className="row">
          <div className="col-md-6">
            <Textbox
              name="primary_first_name"
              label_name="Primary Policy Holder Name"
              required={true}
              placeholder="First Name"
              maxLength="30"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
            />
            {errors.primary_first_name}
          </div>
          <div className="col-md-6">
            <Textbox
              name="primary_last_name"
              required={true}
              placeholder="Last Name"
              maxLength="30"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
            />
            {errors.primary_last_name}
            {errors.primary_name}
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Textbox
              name="member_first_name"
              label_name="Member Being Enrolled"
              required={true}
              placeholder="First Name"
              maxLength="30"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
            />
            {errors.member_first_name}
          </div>
          <div className="col-md-6">
            <Textbox
              name="member_last_name"
              required={true}
              placeholder="Last Name"
              maxLength="30"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
            />
            {errors.member_last_name}
            {errors.member_name}
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <Textbox
              name="member_id"
              label_name="Enrolling HMSA Member ID"
              required={true}
              placeholder="Member ID"
              maxLength="13"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
            />
            <p styles=""></p>
            {errors.member_id}
          </div>
          <div className="col-md-6">
            <DateSelector
              name="member_dob"
              label_name="Enrolling Member Date of Birth"
              required={true}
              selected={user_input.member_dob}
              onChange={date =>
                inputHandler.handleDateChange(date, this, "member_dob", true)
              }
            />
            {errors.member_dob}
          </div>
        </div>
        <h3>Sample ID Card:</h3>
        <div className="row">
          <div className="col">
            <div className="row id-card-display">
              <div>
                <div className="id-card">
                  <div className="row">
                    <img className="id-card-logo" src={hilogo} />
                  </div>
                  <hr className="hr-margin" />
                  <div className="row">
                    <div className="col-5">
                      <p>Subscriber Name</p>
                      <p>
                        <strong>KIMO K ALOHA</strong>
                      </p>
                      <p>Subscriber ID</p>
                      <p>
                        <strong>
                          XLP
                          <span className="highlight-card-text card-tooltip">
                            R001234567890
                            <span className="tooltiptext">
                              Please enter only the highlighted digits. Any
                              digits before the ‘R’ should not be entered.
                            </span>
                          </span>
                        </strong>
                      </p>
                    </div>
                    <div className="col">
                      <p>
                        Group <strong>14520</strong>
                      </p>
                    </div>
                  </div>
                  <br />
                  <hr className="hr-margin" />
                  <div className="row">
                    <div className="col-5">
                      <p>Member Name</p>
                      <p>
                        <strong>KEIKI K ALOHA</strong>
                      </p>
                    </div>
                    <div className="col">
                      <p>
                        MEDICAL <strong>800</strong>
                      </p>
                      <p>
                        DENTAL <strong>V03</strong>
                      </p>
                      <p>
                        VISION <strong>0AI</strong>
                      </p>
                    </div>
                    <div className="col">
                      <p>
                        DRUG <strong>515</strong>
                      </p>
                      <p>
                        RXBIN <strong>004336</strong>
                      </p>
                      <p>
                        RXPCN <strong>ADV</strong>
                      </p>
                      <p>
                        RXGRP <strong>RX3989</strong>
                      </p>
                    </div>
                  </div>
                  <br />
                  <hr className="hr-margin" />
                  <div className="row float-right">
                    <img className="id-card-logo-bottom " src={ppo} />
                  </div>
                </div>
                <div className="row">
                  <div className="id-card-info col">
                    Please enter only the highlighted digits. Any digits before
                    the ‘R’ should not be entered.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="row id-card-display">
              <div>
                <div className="id-card">
                  <div className="row">
                    <img className="id-card-logo" src={hilogo} />
                    <div className="col ">
                      <p className="float-text-right">
                        <strong>(PPO)</strong>
                      </p>
                    </div>
                  </div>
                  <hr className="hr-margin" />
                  <div className="row">
                    <div className="col-5">
                      <p>Subscriber Name</p>
                      <p>
                        <strong>KIMO K ALOHA</strong>
                      </p>
                    </div>
                    <div className="col">
                      <p>
                        Group <strong>M12461</strong>
                      </p>
                    </div>
                    <div className="col">
                      <img src={medicare} className="medicare-logo" />
                      <p>H3832 008</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <p>Subscriber ID</p>
                      <p>
                        <strong>
                          XLL
                          <span className="highlight-card-text card-tooltip">
                            A000012345678
                            <span className="tooltiptext">
                              Please enter only the highlighted digits. Any
                              digits before the 'A' should not be entered.
                            </span>
                          </span>
                        </strong>
                      </p>
                    </div>
                    <div className="col">
                      <p>Primary Care Provider</p>
                      <p>
                        <strong>DR MOKI HANA</strong>
                      </p>
                    </div>
                  </div>
                  <hr className="hr-margin" />
                  <div className="row dual-care">
                    <div className="col">
                      <p>PLAN <strong>(80840)</strong></p>
                      <p>
                        RXBIN <strong>004336</strong>
                      </p>
                      <p>
                        RXPCN <strong>MEDDADV</strong>
                      </p>
                      <p>
                        RXGRP <strong>RX3982</strong>
                      </p>
                      <p>
                        RXIO <strong>A000012345678</strong>
                      </p>
                    </div>           
                    <div className="col">
                      <p>
                        MEDICAL <strong>695</strong>
                      </p>
                      <p>
                        PART D <strong>785</strong>
                      </p>
                    </div>
                    <div className="col">
                      <p>
                        DENTAL <strong>N08</strong>
                      </p>
                      <p>
                        VISION <strong>0MB</strong>
                      </p>
                      <p>
                        CMPCARE <strong>S01</strong>
                      </p>
                    </div>
                    <div className="col">
                       <img src={qr} className="qr-img" />
                    </div>
                  </div>
                  <div className="dual-care">
                    <p>
                      Generated 08-16-2022
                    </p>
                  </div>
                  <hr className="hr-margin" />
                  <div className="row">
                    <div className="col float-left">
                       <img className="id-card-aa-logo-bottom" src={advantage} />
                    </div>
                    <div className="row float-right">
                       <img className="id-card-ma-logo-bottom" src={mappo} />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="id-card-info col">
                    Please enter only the highlighted digits. Any digits before
                    the 'A' should not be entered.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="form-group">
          <input
            disabled={!form_is_valid}
            type="submit"
            className="btn button button-primary buttonBlue"
            onClick={e =>
              submissionHandler.BuildHIPrevalidation(this).handleSubmit(e)
            }
            value="Check Eligibility"
          />
          <div id="required-description">
            <span aria-hidden="true" className="text-danger">
              *
            </span>
            Required field
          </div>
        </div>
        {errors.default_error}
      </div>
    );

    var modal = null;
    if (is_loading) {
      modal = <LoadingModal />;
    }

    var currentRoute = window.location.href.replace(/^.*\/\/[^\/]+/, "");
    var validationRoute = "/hi/dentalforhealth/validate";
    if (success && currentRoute !== validationRoute) {
      return (
        <Redirect
          to={{
            pathname: validationRoute,
            user_input,
            success
          }}
        />
      );
    }

    return (
      <div>
        {page}
        {modal}
      </div>
    );
  };
}
